<svelte:head>
  <title>{bookTitle}</title>
  <link rel="canonical" href={pageUrl}>
  <meta property="og:url" content={pageUrl}>
  <meta name="description" content={bookDescription}>
  <meta property="og:type" content="books.book">
  <meta property="og:title" content={bookTitle}>
  <meta property="og:description" content={bookAnnotation}>
  {#if bookCover}
    <meta property="og:image" content={bookCover}>
  {/if}
  {@html `<script type="application/ld+json">${bookSchema}</script>`}
</svelte:head>

<BookInfo {book} />

<script context="module">
  export async function preload({ query: { id } }, session) {
    if (!id) {
      return this.error(404, 'Not found');
    }

    try {
      const json = await this.fetch(`/api/books/${id}?lang=${session.lang}`, {
        credentials: 'include'
      }).then((res) => res.json());

      if (!json.book) {
        return this.error(404, 'Not found');
      }

      return {
        book: {
          ...json.book,
          productCard: json.productCard,
          price: json.price,
          isDeferred: json.isDeferred
        }
      };
    } catch(error) {
      this.error(500, error);
    }
  }
</script>

<script>
  import { _ } from 'svelte-intl';
  import { get } from 'svelte/store';
  import { stores } from '@sapper/app';
  import * as urlFor from '../../helpers/urlFor';

  import BookInfo from '../../components/book-info/BookInfo.svelte';

  import formatAnnotation from '../../helpers/formatAnnotation';

  const { page } = stores();

  export let book;

  const pageUrl = `https://${$page.host}${urlFor.book(book)}`;

  $: bookTitle = get(_)('book_title', {
    title: book.title,
    authors: book.authors.map((author) => author.personName).join(', ')
  });
  $: bookAnnotation = formatAnnotation(book.annotation);
  $: bookCover = book.cover && book.cover.url;

  $: bookSchema = JSON.stringify({
    '@context': 'http://schema.org',
    '@type': 'Book',
    'bookFormat': 'EBook',
    'name': book.title,
    'description': bookAnnotation,
    'image': bookCover,
    'author': book.authors.map((author) => ({
      '@type': 'Person',
      'name': author.personName
    }))
  });

  $: bookDescription = get(_)('book_description', {
    title: book.title,
    annotation: `${bookAnnotation.slice(0, 100)}…`
  });
</script>
